/* global pendo */
import { useEffect, useState, createContext } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./WazKBRoot.css";
import { selectUser } from "../../../redux/features/appData";
import { WazToolbar } from "../../wazawan/toolbar/WazToolbar";
import { WazKBToolbar } from "./WazKBToolbar";

type WazRootProps = {

};
export const WazKBRoot = ({}: WazRootProps) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeUser = useSelector(selectUser);

  if (storeUser) {
    document.body.className = storeUser.theme;
  }

  console.log("[WazKBRoot/main] storeUser: ", storeUser);

  return (
        <>
            <div id="waz-kb-root">
                <WazToolbar viewingApp={true}/>
                <WazKBToolbar />
                
                <div className="waz-kb-body">
                    <Outlet context={[]} />
                </div>
                
                
            </div>

            <Toaster />
        </>
  );
}
